import { render, staticRenderFns } from "./WhatsappConfiguracoesSimples.vue?vue&type=template&id=5686daf6"
import script from "./WhatsappConfiguracoesSimples.vue?vue&type=script&lang=js"
export * from "./WhatsappConfiguracoesSimples.vue?vue&type=script&lang=js"
import style0 from "./WhatsappConfiguracoesSimples.vue?vue&type=style&index=0&id=5686daf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports